import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerAccount } from './customer-account.model';
import { PurchaseChannel } from '@ridango/core/lib/enums/purchase-channel.enum';
import { getPurchaseChannel } from '@ridango/core/lib/utils/channel.util';
import Env from '@ridango/core/env';

@Injectable()
export class CustomerAccountsService {
    constructor(
        @Inject('ENV') private env: Env,
        private http: HttpClient
    ) {}

    fetchCustomerAccounts(): Observable<CustomerAccount[]> {
        const channel: PurchaseChannel = getPurchaseChannel(this.env);
        const url = `${this.env.WMB.WMB_PUBLIC_API}/v1/afc-customers/customer-accounts/channel/${channel}`;
        return this.http.get<CustomerAccount[]>(url);
    }
}
